<template>
  <div>
    <div class="row justify-content-center">
      <!-- Join Campaign -->
      <div class="card shadow mt-2">
        <div class="card-body p-4 d-flex align-items-center">
          <!-- Image -->
          <div class="success-image-background p-3" style="border-radius: 50%">
            <img
              src="@/assets/img/campaign/join_icon.png"
              alt="Join Icon"
              class="img-fluid"
              style="max-width: 1.5rem"
            />
          </div>

          <!-- Label -->
          <div class="ml-4">
            <p
              class="font-weight-bold headline text-color mb-0"
              style="font-size: 0.9rem !important"
            >
              キャンペーン参加
            </p>
          </div>
        </div>

        <!-- Status -->
        <div
          class="card-footer border-0 success-card-footer"
          style="
            border-bottom-left-radius: 1rem;
            border-bottom-right-radius: 1rem;
          "
        >
          <p
            class="text-center mb-0 font-weight-bold text-bold text-color"
            style="font-size: 0.7rem !important"
          >
            認証済みです
          </p>
        </div>
      </div>

      <!-- Follow Twitter -->
      <div class="card shadow mt-2" @click="toTwitterProfile()">
        <div class="card-body p-4 d-flex align-items-center">
          <!-- Image -->
          <div
            v-if="isFollow"
            class="success-image-background p-3"
            style="border-radius: 50%"
          >
            <img
              src="@/assets/img/campaign/follow_icon.png"
              alt="Follow Icon"
              class="img-fluid"
              style="max-width: 1.5rem"
            />
          </div>

          <div
            v-else
            class="fail-image-background p-3"
            style="border-radius: 50%"
          >
            <img
              src="@/assets/img/campaign/not_follow_icon.png"
              alt="Not Follow Icon"
              class="img-fluid"
              style="max-width: 1.5rem"
            />
          </div>

          <!-- Label -->
          <div class="ml-4">
            <p
              class="font-weight-bold headline text-color mb-0"
              style="font-size: 0.9rem !important"
            >
              フォロワーが条件です
            </p>
          </div>
        </div>

        <!-- Status -->
        <div
          v-if="isFollow"
          class="card-footer border-0 success-card-footer"
          style="
            border-bottom-left-radius: 1rem;
            border-bottom-right-radius: 1rem;
          "
        >
          <p
            class="text-center mb-0 font-weight-bold text-bold text-color"
            style="font-size: 0.7rem !important"
          >
            @{{ sns_account_name }}をフォロー済です
          </p>
        </div>

        <div
          v-else
          class="card-footer border-0 fail-card-footer"
          style="
            border-bottom-left-radius: 1rem;
            border-bottom-right-radius: 1rem;
          "
        >
          <p
            class="text-center mb-0 font-weight-bold text-bold text-color"
            style="font-size: 0.7rem !important"
          >
            @{{ sns_account_name }}のフォローをお願いします
          </p>
        </div>
      </div>

      <!-- Retweet -->
      <div class="card shadow my-2" @click="toTwitterPost()">
        <div class="card-body p-4 d-flex align-items-center">
          <!-- Image -->
          <div
            v-if="isRetweet"
            class="success-image-background p-3"
            style="border-radius: 50%"
          >
            <img
              src="@/assets/img/campaign/retweet_icon.png"
              alt="Retweet Icon"
              class="img-fluid"
              style="max-width: 1.5rem"
            />
          </div>

          <div
            v-else
            class="fail-image-background p-3"
            style="border-radius: 50%"
          >
            <img
              src="@/assets/img/campaign/not_retweet_icon.png"
              alt="Not Retweet Icon"
              class="img-fluid"
              style="max-width: 1.5rem"
            />
          </div>

          <!-- Label -->
          <div class="ml-4">
            <p
              class="font-weight-bold headline text-color mb-0"
              style="font-size: 0.9rem !important"
            >
              リツイートが条件です
            </p>
          </div>
        </div>

        <!-- Status -->
        <div
          v-if="isRetweet"
          class="card-footer border-0 success-card-footer"
          style="
            border-bottom-left-radius: 1rem;
            border-bottom-right-radius: 1rem;
          "
        >
          <p
            class="text-center mb-0 font-weight-bold text-bold text-color"
            style="font-size: 0.7rem !important"
          >
            対象ツイートをリツイート済です
          </p>
        </div>

        <div
          v-else
          class="card-footer border-0 fail-card-footer"
          style="
            border-bottom-left-radius: 1rem;
            border-bottom-right-radius: 1rem;
          "
        >
          <p
            class="text-center mb-0 font-weight-bold text-bold text-color"
            style="font-size: 0.7rem !important"
          >
            必須：対象ツイートのリツイートをお願いします
          </p>
        </div>
      </div>

      <!-- Retweet Description -->
      <small
        class="text-right text text-color font-weight-bold mb-5"
        style="width: 80vw; min-width: 80vw; font-size: 0.5rem !important"
        >※引用リツイートは対象外です。コメントを付けずにリツイートしてください。</small
      >
    </div>
  </div>
</template>

<script>
import { checkShareLine } from "@/api/campaign";
import { getAuthenResponse, getUserAgentMobile } from "@/utils/auth";
import { setErrorMessage } from "@/utils/error";
import { getCampaignId } from "@/utils/campaign";

export default {
  data() {
    return {
      sns_account_name: null,
      isFollow: false,
      isRetweet: false,
      twitterPostUrl: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    const query = {
      campaign_id: getCampaignId(),
      user_agent_mobile: getUserAgentMobile()
    };

    checkShareLine(query)
      .then((response) => {
        if (response.status === "success") {
          let url = response.result.url;

          // Check user agent to get twitter tweet url
          if (getUserAgentMobile() == 'true') {
            let index = url.indexOf('%0Ahttps://')

            if (index > 0) {
              url = url.substring(index + 3)
            }
          } else {
            let index = url.indexOf('&text=')

            if (index > 0) {
              url = url.substring(0, index)
            }
          }

          return next((vm) => {
            vm.setTwitterPostUrl(url);
          });
        } else {
          throw new Error(response);
        }
      })
      .catch((error) => {
        setErrorMessage(error.statusCode);
        return next("/error");
      });
  },
  created() {
    const response = getAuthenResponse();

    if (!response) {
      return this.$router.push("/not-permission");
    }

    // check and get sns_account_name
    if (response.result.sns_account_name) {
      this.sns_account_name = response.result.sns_account_name;
    } else {
      return this.$router.push("/not-permission");
    }

    // check and get tweet status
    switch (response.status) {
      case "not_follow":
        this.isFollow = false;
        this.isRetweet = true;
        break;
      case "not_retweet":
        this.isFollow = true;
        this.isRetweet = false;
        break;
      case "not_retweet_follow":
        this.isFollow = false;
        this.isRetweet = false;
        break;
      default:
        return this.$router.push("/not-permission");
    }
  },
  methods: {
    toTwitterProfile() {
      if (!this.isFollow) {
        const twitterLink = "https://twitter.com/" + this.sns_account_name;
        window.open(twitterLink, "_blank");
      }
    },
    setTwitterPostUrl(url) {
      this.twitterPostUrl = url;
    },
    toTwitterPost() {
      window.open(this.twitterPostUrl, "_blank");
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 1rem;
  min-width: 80vw !important;
  width: 80vw !important;
}

.success-image-background,
.success-card-footer {
  background-color: #ffd803;
  border: 1px solid #ffd803;
}

.fail-image-background {
  background-color: #273243;
  border: 1px solid #273243;
}

.fail-card-footer {
  background-color: #dfdfdf;
  border: 1px solid #dfdfdf;
}
</style>
